<app-accordion-help [helps]="helps"></app-accordion-help>
<ng-container *ngIf="is_loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>

<div style="margin-top: 20px; margin-left: 20px">
  <button mat-raised-button color="accent" (click)="goBack()">Back</button>
</div>


<ng-container *ngIf="!is_loading">


  <form [formGroup]="myForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate>


    <div style="margin-top: 20px; margin-left: 20px">
    <mat-form-field>
      <mat-label>Shop Name:</mat-label>
      <input style="text-align: right;" matInput formControlName="shop_name">
      <span matSuffix>.myshopify.com</span>
    </mat-form-field>
    </div>




    <ng-container *ngIf="!is_redirect_url">
      <div style="margin-top: 20px; margin-left: 20px">
        <button mat-raised-button color="primary" [disabled]="!myForm.valid" type="submit">Add Shopify Account</button>
      </div>
    </ng-container>
  </form>

  <ng-container *ngIf="is_redirect_url">
    <div style="margin-top: 20px; margin-left: 20px">
      <button mat-raised-button color="primary"  (click)="onPop()" [disabled]="!myForm.valid">Reauthorize</button>
      <button style ="margin-left: 10px" mat-raised-button color="warn"  (click)="onDelete()" [disabled]="!myForm.valid" type="button">Delete</button>
    </div>
  </ng-container>



  <div style="margin-top: 20px; margin-left: 20px">
    <mat-slide-toggle [checked]="checked" [color]="color"> Connected</mat-slide-toggle>
  </div>


</ng-container> <!-- end is loading-->
